<div class="canvas-ribbon">
	<ng-container *ngFor="let canvas of posService.venueService.ooCanvases | arrayFilter: { online: true }">
		<p-button pRipple styleClass="p-button-raised p-button-info canvas-ribbon-button m-2" (click)="selectCanvas(canvas.canvasKey)">
			<ng-template pTemplate="content">
				<div class="d-flex mx-auto canvas-ribbon-text">
					{{ canvas.displayName || canvas.name }}
				</div>
			</ng-template>
		</p-button>
	</ng-container>
</div>
